import { render, staticRenderFns } from "./Kurtosis.vue?vue&type=template&id=0b2bc300&scoped=true"
var script = {}
import style0 from "./Kurtosis.vue?vue&type=style&index=0&id=0b2bc300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2bc300",
  null
  
)

export default component.exports